module.exports = __webpack_public_path__ + "static/media/faisal-nasim-edu-games-plus.3416585b.jpg";